export const POST = [
  "id",
  "name",
  "uuid",
  "width",
  "height",
  "_position",
  "templateId",
  "finalImage",
  "dataObjects",
  "folderId",
  "typeUser",
  "clientId",
];
